<template>
    <div class="subAccountAdd">
        <div class="form deletemg">
            <div class="basicMsg"><span class="tips">|</span>基本信息</div>
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
                <el-form-item label="资鲸账号" prop="customerloginname" class="account">
                    <el-input v-model.trim="form.customerloginname" placeholder="请输入对应账号的手机号（可登录小资鲸内容管理后台）" :disabled="!!form.innerid" clearable></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="username" class="username">
                    <el-input v-model.trim="form.username" placeholder="请输入对应的账号姓名" maxlength="30" show-word-limit clearable></el-input>
                </el-form-item>
                <el-form-item label="头像">
                    <div class="upload cover-image">
                        <div class="avatar-uploader">
                            <div class="el-upload el-upload--text" @click="localCropperOpenDialog">
                                <!-- <i class="el-icon-user-solid" v-if="!ruleForm.headimginfo.furl"></i> -->
                                <img :src="require('@/common/images/other/icon_headImg@2x.png')" v-if="!form.headatturl.furl" alt="">
                                <img :src="form.headatturl.furl +'?'+timestamp" alt="" class="avatar" v-if="form.headatturl.furl">
                            </div>
                            <div class="el-upload__tip">建议像素：120（宽）*120（高），JPG、PNG格式，大小不超过5M。</div>
                        </div>
                    </div>
                    <!-- <div class="avatarBox">
                        <upload class="headImage" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                        <p class="avatarTips">建议像素：120（宽）*120（高），JPG、PNG格式，大小不超过5M。</p>
                    </div> -->
                </el-form-item>
                <el-form-item label="简介">
                    <el-input type="textarea" v-model.trim="form.desp" placeholder="请输入内容" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-radio-group v-model="form.status">
                    <el-radio :label="1">启用</el-radio> <br><br>
                    <el-radio :label="0">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div class="rootSet"><span class="tips">|</span>权限设置</div>
                <el-form-item class="roleBox" label="角色">
                    <el-checkbox-group v-model="form.roleinnerid">
                        <el-checkbox :label="role.innerid" v-for="role in roleList" :key="role.innerid" @change="getRolePower(role)" :ref="'roleinnerid' +role.innerid">
                            <span>{{role.rolename}}</span>
                            <!--<span class="default">默认</span>-->
                        </el-checkbox>
                    </el-checkbox-group>
                    <div class="rootContent">
                        <powerTree ref="powerTree" :isDisabled="true"></powerTree>
                    </div>
                </el-form-item>
                <el-form-item class="action">
                    <el-button @click="resetForm('form')">取消</el-button>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--<el-dialog @open="openDialog" title="提示" :before-close="closeDialog" :visible.sync="dialogFormVisible" :close-on-press-escape="false" :close-on-click-modal="false">-->
            <!--<p class="tipsText">由于您操作的⻆色中包含高级管理员/普通管理员/财务管理<br> 基于安全考虑，需要短信验证</p>-->
            <!--<el-form :model="dealogData">-->
                <!--<input prop="code" @blur="checkCode" class="code" v-model="dealogData.verifyCode" autocomplete="off" placeholder="输入验证码"/><el-button>获取验证码</el-button>-->
                <!--<p class="errTips" v-show="showErrTips">{{errTips}}</p>-->
            <!--</el-form>-->
            <!--<div slot="footer" class="dialog-footer">-->
                <!--<el-button @click="cancel">取 消</el-button>-->
                <!--<el-button type="primary" @click="confirm">确 定</el-button>-->
            <!--</div>-->
        <!--</el-dialog>-->
        <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></localCropper>
    </div>
</template>
<script>
import Upload from 'base/upload/upload'
import {addChildAccount, getRoleList, getRoleView, getChildAccountView, editChildAccount} from '@/api/subAccountApi'
import {formatFileInfo} from '@/common/js/tools'
import LocalCropper from 'base/cropper/localCropper'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
import PowerTree from 'base/tree/powerTree'
export default {
    name: 'subAccountAdd',
    data() {
        return {
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            imgRule: {
                cls: 'icon_headImg',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: '',
                height: ''
            },
            roleList: [],
            timestamp: new Date().getTime(),
            form: {
                innerid: this.$route.query.id ? this.$route.query.id : '',
                customerloginname: '',
                username: '',
                desp: '',
                status: 1,
                headatturl: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                },
                roleinnerid: []
            },
            rules: {
                customerloginname: [
                    {required: true, message: '请输入资鲸账号', trigger: 'blur'},
                    {pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号码', trigger: 'blur'}
                ],
                username: [
                    {required: true, message: '请输入姓名', trigger: 'blur'}
                ]
            },
            rootData: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            rootDefaultChecked: [],
            dealogData: {
                verifyCode: ''
            },
            cropperOption: {
                fixedNumber: [512, 512], // 截图框的宽高比例
                enlarge: 2.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 120, // 默认生成截图框宽度
                autoCropHeight: 120 // 默认生成截图框高度
            },
            dialogFormVisible: false,
            errTips: '请输入验证码',
            showErrTips: false,
            role: null
        }
    },
    mounted() {
        this._getRoleList()
        if (this.form.innerid) {
            this._getAccountView()
        }
    },
    methods: {
        setCoverfile(img) {
            this.form.headatturl = img
        },
        // 数据提交函数
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.form.headatturl = formatFileInfo(this.form.headatturl)
                    let tmp = Object.assign({}, this.form)
                    if (tmp.roleinnerid) {
                        this.$confirm('请确认您的输入信息是否完整正确？', '提交资料', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            closeOnClickModal: false
                        }).then(() => {
                            tmp.roleinnerid = tmp.roleinnerid.length ? tmp.roleinnerid.join(',') : ''
                            if (tmp.innerid) {
                                this._editChildAccount(tmp)
                            } else {
                                this._addChildAccount(tmp)
                            }
                        }).catch(() => {})
                    } else {
                        this.$alert('请配置角色！', '提示', {
                            dangerouslyUseHTMLString: true
                        })
                    }
                }
            })
        },
        localCropperOpenDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setImage(file) {
            this.timestamp = new Date().getTime()
            this.form.headatturl = file
        },
        _editChildAccount(tmp) {
            this.setLoading(true)
            editChildAccount({
                data: tmp,
                success: data => {
                    this.$message.success('保存成功')
                    this.setLoading(false)
                    this.$router.back()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _addChildAccount(tmp) {
            this.setLoading(true)
            addChildAccount({
                data: tmp,
                success: data => {
                    this.$message.success('保存成功')
                    this.setLoading(false)
                    this.$router.back()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        resetForm(formName) {
            this.$router.back()
        },
        // 检查验证码
        checkCode() {
            if (this.dealogData.verifyCode) {
                this.$message.error('请输入验证码')
            } else {
                this.showErrTips = false
            }
        },
        // 弹出框 确认按钮
        getRolePower(role) {
            // let checked = !this.$refs['roleinnerid' + role.innerid][0].$el.getAttribute('aria-checked')
            // if (checked) {
            //     this.$refs.powerTree._getRoleView(role.innerid)
            // } else {
            //     this.$refs.powerTree._cancal()
            // }
            let roleId = this.form.roleinnerid.length ? this.form.roleinnerid.join(',') : ''
            this.$refs.powerTree._getRoleView(roleId)
        },
        // 弹出框 取消按钮
        cancel() {
            // this.form.rootData.financing.selected = false
            // this.form.rootData.commonManagerChecked.selected = false
            // this.form.rootData.expertManagerChecked.selected = false
            this.dialogFormVisible = false
            this.$refs.tree.setCheckedKeys([])
            this.rootDefaultChecked = []
        },
        // 关闭弹出框触发的函数
        closeDialog() {
            this.form.rootData.financing.selected = false
            this.form.rootData.commonManagerChecked.selected = false
            this.form.rootData.expertManagerChecked.selected = false
            this.dialogFormVisible = false
        },
        // 打开弹出框触发的函数
        openDialog() {
            this.showErrTips = false
        },
        // 禁用选择框
        _computeSelected(data) {
            compute(data)
            function compute(data) {
                data.forEach(obj => {
                    obj.disabled = true
                    if (obj.children && obj.children.length) {
                        compute(obj.children)
                    }
                })
            }
            return data
        },
        _getRoleView(role) {
            this.setLoading(true)
            getRoleView({
                data: {innerid: role.innerid},
                success: data => {
                    this.rootData = this._computeSelected(data.data.menu)
                    this.rootDefaultChecked = data.data.selnode
                    this.$nextTick(() => {
                        $('.cls1').parent().parent().each((index, element) => {
                            // $(element).children().last().css({display: 'flex'})
                            $(element).find('.el-tree-node__children').css({display: 'flex'})
                        })
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getRoleList() {
            this.setLoading(true)
            getRoleList({
                data: {page: '1', pageSize: '10'},
                success: data => {
                    this.roleList = data.data.content
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getAccountView() {
            this.setLoading(true)
            getChildAccountView({
                data: {innerid: this.form.innerid},
                success: data => {
                    data.data.roleinnerid = data.data.roleinnerid.split(',')
                    this.form = data.data
                    // this.$refs.coverfile.setImage(this.form.headatturl.furl)
                    this.setLoading(false)
                    if (this.form.roleinnerid[0]) {
                        let _this = this
                        this.$nextTick(() => {
                            _this.$refs.powerTree._getRoleView(_this.form.roleinnerid[0])
                        })
                    }
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {
        Upload,
        PowerTree,
        LocalCropper
    }
}
</script>
<style lang="scss">
@import "~common/scss/base";
    .subAccountAdd{
        .deletemg{
            margin-top: 0;
            .account,.username{
                .el-form-item__error{
                    top: 92%;
                    padding-top: 0;
                }
            }
        }
        .basicMsg,.rootSet{
            font-weight: 500;
            font-size: 16px;
            margin-bottom: 10px;
            .tips{
                color: #409EFF;
                margin-right: 4px;
                position: relative;
                top: -2px;
            }
        }
        .el-form-item {
            margin-bottom: 10px;
        }
        .el-input{
            width: 400px;
        }
        .el-textarea{
            width: 400px;
            .el-textarea__inner{
                resize: none;
                height: 110px;
            }
        }
        .el-radio-group{
            // height: 50px;
            padding-top: 14px;
            .el-radio{
                margin-bottom: 10px;
            }
        }
        .upload{
            width: 540px;
            .avatar-uploader{
                height: 80px;
                margin-bottom: 12px;
                display: flex;
                .el-upload{
                    width: 80px;
                    height: 80px;
                    border:1px dashed #ccc;
                    img{
                        width: 40px;;
                        height: 44px;
                    }
                    .avatar{
                        width: 100%;
                        height: 100%;
                    }
                    .el-icon-user-solid{
                        font-size: 34px;
                        line-height: 80px;
                        color: #A0CFFF;
                    }
                }
                .el-upload__tip{
                    color: #909399;
                    position: relative;
                    top: -10px;
                    margin-left: 15px;
                }
            }
            // .avatarTips{
            //     font-size: 14px;
            //     color: #909399;
            //     vertical-align: top;
            //     margin-left: 15px;
            // }
        }
        .roleBox{
            .el-form-item__content{
                .el-checkbox{
                    .el-checkbox__label{
                        .default{
                            width:36px;
                            height:17px;
                            border: 1px solid #409EFF;
                            color: #409EFF;
                            text-align: center;
                            display: inline-block;
                            margin-left: 6px;
                            box-sizing: border-box;
                            font-size: 12px;
                        }
                    }
                }
                .rootContent{
                    background: #F5F7FA;
                    margin-top: 22px;
                    padding-left: 16px;
                    padding-top: 20px;
                    min-height: 500px;
                    .el-tree{
                        background: none;
                    }
                }
            }
        }
        .action{
            text-align: center;
        }
        .el-dialog{
           .el-form{
                padding-left: 158px;
                padding-top: 40px;
                height: 100px;
                box-sizing: border-box;
                .code{
                    width: 175px;
                    height: 32px;
                    border-radius:4px;
                    border: 1px solid #C0C4CC;
                    outline: none;
                    text-indent: 12px;
                    box-sizing: border-box;
                    margin-right: 20px;
                }
                .el-button{
                    margin-bottom: 4px;
                }
                .errTips{
                    color: #F56C6C;
                    margin: 0;
                    font-size: 12px;
                    text-indent: 12px;
                }
            }
            .tipsText{
                margin-top: 24px;
                color: #F56C6C;
                text-align: center;
                line-height: 24px;
            }
        }

    }
</style>
